/**
 * Module-level mirror of connectivity, updated by NetworkProvider.
 * Exists so non-React code (the Axios interceptor) can consult network state.
 * Defaults to online so behavior is unchanged until the provider mounts.
 */
let online = true;

export const setNetworkOnline = (value: boolean): void => {
  online = value;
};

export const getNetworkOnline = (): boolean => online;
